var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 0C10.5663 0 11.0169 0.200326 11.3252 0.541992L12.3584 1.66699H15C15.9166 1.66699 16.6668 2.41649 16.667 3.33301V13.333C16.667 14.2497 15.9167 15 15 15H1.66699C0.750326 15 0 14.2497 0 13.333V3.33301C0.000177488 2.41649 0.750434 1.66699 1.66699 1.66699H4.30859L5.33301 0.541992C5.64962 0.200389 6.09983 7.43719e-05 6.56641 0H10.0996ZM8.33301 4C6.03316 4.00018 4.167 5.8671 4.16699 8.16699C4.16699 10.4669 6.03316 12.3338 8.33301 12.334C10.633 12.334 12.5 10.467 12.5 8.16699C12.5 5.86699 10.633 4 8.33301 4ZM8.33301 5.66699C9.71372 5.66699 10.833 6.78628 10.833 8.16699C10.8328 9.54754 9.7136 10.667 8.33301 10.667C6.9526 10.6668 5.8332 9.54741 5.83301 8.16699C5.83301 6.78641 6.95248 5.66721 8.33301 5.66699Z",
    fill: "#DFDEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.603137b7.svg";
export { ForwardRef as ReactComponent };